import { c as _c } from "react/compiler-runtime";
import { BreadcrumbItem } from '@src/contexts/ActiveContentContext';
import { startupsUrl } from '@src/lib/startups-url';
import { BreadcrumbJsonLd } from 'next-seo';
export const BreadcrumbSEO = props => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let items = t0;
  ;
  try {
    let t2;
    if ($[1] !== props.breadcrumbs) {
      t2 = props.breadcrumbs.map(_temp);
      $[1] = props.breadcrumbs;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    items = t2;
  } catch (t1) {
    const err = t1;
    console.log({
      err
    });
  }
  let t2;
  if ($[3] !== items) {
    t2 = <BreadcrumbJsonLd items={items} scriptKey="site-breadcrumbs" />;
    $[3] = items;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(item) {
  return {
    name: item.title,
    item: startupsUrl(item.href)
  };
}